import { CellWrapper } from "@silevis/reactgrid";
import _ from "lodash";
import { FC } from "react";

export interface NonEditableCellCellProps {
    text: string;
    style?: React.CSSProperties;
}

export const NonEditableCell: FC<NonEditableCellCellProps> = ({ text, style }) => {
    return (
        <CellWrapper
            onStringValueRequested={() => text}
            onStringValueReceived={() => text}
            style={{ padding: ".2rem", textAlign: "center", outline: "none", whiteSpace: 'nowrap', ...style }}
        >
            {_.isEmpty(text) ? '' : text}
        </CellWrapper>
    );
};